// Constantes compartilhadas do Coremail

export const FOLDERS = [
  { id: 'inbox', name: 'Caixa de Entrada', icon: 'Inbox' },
  { id: 'starred', name: 'Favoritos', icon: 'Star' },
  { id: 'sent', name: 'Enviados', icon: 'Send' },
  { id: 'drafts', name: 'Rascunhos', icon: 'FileText' },
  { id: 'spam', name: 'Spam', icon: 'AlertOctagon' },
  { id: 'trash', name: 'Lixeira', icon: 'Trash2' },
  { id: 'archive', name: 'Arquivo', icon: 'Archive' },
];

export const TAG_COLORS = [
  { id: 'red', label: 'Vermelho', css: 't-red' },
  { id: 'blue', label: 'Azul', css: 't-blue' },
  { id: 'green', label: 'Verde', css: 't-green' },
  { id: 'yellow', label: 'Amarelo', css: 't-yellow' },
  { id: 'purple', label: 'Roxo', css: 't-purple' },
  { id: 'pink', label: 'Rosa', css: 't-pink' },
  { id: 'orange', label: 'Laranja', css: 't-orange' },
];

export const TAG_COLOR_HEX = {
  red: '#EF4444', blue: '#3B82F6', green: '#10B981',
  yellow: '#F59E0B', purple: '#8B5CF6', pink: '#EC4899', orange: '#F97316',
};
